const fields = [
  {
    name: 'customer_notes',
    showKey: 'customer_notes',
    type: 'select-resourceful-v2',
    label: 'Catatan Khusus Pelanggan',
    optionsGetter: null, // Null because we will define the getter in form
    optionLabelFn: ({ item }) => item.note,
    trackBy: 'note',
    placeholder: 'Pilih Catatan Khusus Pelanggan',
    multiple: true,
    taggable: true,
  },
  {
    name: 'note',
    showKey: 'note',
    label: 'Catatan Lainnya',
    placeholder: 'Masukkan catatan lainnya disini...',
    type: 'textarea',
    validation: 'max:255,length',
  },
]

export default fields
